import React from 'react'
import { Box, Button, Divider, Drawer, Typography } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'
import AppsRoundedIcon from '@mui/icons-material/AppsRounded'
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded'
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded'
import PersonRoundedIcon from '@mui/icons-material/PersonRounded'
// import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded'
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded'
import SyncRoundedIcon from '@mui/icons-material/SyncRounded'
import { APP_DATA } from '../../data'
import { puedeVerPanelAdmin } from '../../utils/permisos'
import { getAssignedApplicationLinks } from '../../services/user/sessionSelectors'
import LogoSuite from '../../media/LOGO_CLASOL SUITE_APPS.png'
import { ApplicationIcon } from '../applications/ApplicationIcon'

const platformItems = [
  { label: 'Aplicaciones', icon: <AppsRoundedIcon />, path: '/admin/aplicaciones' },
  { label: 'Integraciones y servicios', icon: <SyncRoundedIcon />, path: '/admin/integraciones' },
  { label: 'Usuarios', icon: <PersonRoundedIcon />, path: '/admin/usuarios' },
  { label: 'Roles y permisos', icon: <ShieldRoundedIcon />, path: '/admin/roles' },
  // Configuración oculta temporalmente; conservar para su futura activación.
  // { label: 'Configuración', icon: <SettingsRoundedIcon />, path: '/admin/configuracion' },
  { label: 'Auditoría', icon: <AssignmentRoundedIcon />, path: '/admin/auditoria' },
]

const SidebarButton = ({ item, collapsed, onClose, className = 'suite-nav-button suite-nav-button-muted' }) => (
  <Button
    component={item.external ? 'a' : NavLink}
    {...(item.external ? { href: item.path, target: '_blank', rel: 'noopener noreferrer' } : { to: item.path })}
    onClick={onClose}
    startIcon={item.icon}
    className={className}
    title={collapsed ? item.label : undefined}
  >
    <span className="suite-nav-label">{item.label}</span>
  </Button>
)

const SidebarContent = ({ usuario, onClose, collapsed, onToggleCollapse, mobile }) => {
  const location = useLocation()
  const isAdminArea = location.pathname.startsWith('/admin')
  const showAdminSection = isAdminArea && puedeVerPanelAdmin(usuario)
  const applicationItems = getAssignedApplicationLinks(usuario).map((application) => ({
    label: application.title,
    icon: <ApplicationIcon application={application} />,
    path: application.path,
    external: application.external,
  }))

  return (
    <Box className="suite-sidebar-content">
      <Box className="suite-brand">
        <img className="suite-brand-logo" src={LogoSuite} alt={APP_DATA.appName} />
      </Box>

      <Box className="suite-sidebar-section">
        <SidebarButton
          item={{ label: isAdminArea ? 'Panel administrador' : 'Inicio', icon: <DashboardRoundedIcon />, path: isAdminArea ? '/admin' : '/' }}
          collapsed={collapsed}
          onClose={onClose}
          className="suite-nav-button"
        />
      </Box>

      <Box className="suite-sidebar-section">
        <Typography className="suite-sidebar-label">Aplicaciones</Typography>
        {applicationItems.map((item) => (
          <SidebarButton key={item.path} item={item} collapsed={collapsed} onClose={onClose} />
        ))}
      </Box>

      {showAdminSection && (
        <Box className="suite-sidebar-section">
          <Typography className="suite-sidebar-label">Plataforma</Typography>
          {platformItems.map((item) => (
            <SidebarButton key={item.path} item={item} collapsed={collapsed} onClose={onClose} />
          ))}
        </Box>
      )}

      <Box className="suite-sidebar-footer">
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)', mb: 2 }} />
        <Typography className="suite-footer-copy">(c) 2026 {APP_DATA.appName}</Typography>
        <Typography className="suite-footer-version">Version {APP_DATA.version}</Typography>
        {!mobile && (
          <>
            <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)', my: 2 }} />
            {/* <Box
              className="suite-collapse-row"
              onClick={onToggleCollapse}
              title={collapsed ? 'Expandir menu' : 'Colapsar menu'}
            >
              <IconButton size="small" sx={{ color: '#ffffff' }}>
                {collapsed ? <ChevronRightRoundedIcon /> : <ChevronLeftRoundedIcon />}
              </IconButton>
              <Typography>{collapsed ? 'Expandir' : 'Contraer'}</Typography>
            </Box> */}
          </>
        )}
      </Box>
    </Box>
  )
}

export const Sidebar = ({ open, mobile, collapsed, onClose, onToggleCollapse, session }) => {
  if (mobile) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          '& .MuiDrawer-paper': {
            width: 'min(88vw, 256px)',
            background:
              'linear-gradient(180deg, rgba(255, 121, 0, 0.06), rgba(255, 121, 0, 0) 38%), #071017',
            color: '#ffffff',
            borderRight: '1px solid rgba(255, 255, 255, 0.08)',
            overflow: 'hidden',
          },
        }}
        PaperProps={{
          className: 'suite-sidebar-drawer',
          sx: {
            width: 'min(88vw, 256px)',
            background:
              'linear-gradient(180deg, rgba(255, 121, 0, 0.06), rgba(255, 121, 0, 0) 38%), #071017',
            color: '#ffffff',
            borderRight: '1px solid rgba(255, 255, 255, 0.08)',
            overflow: 'hidden',
          },
        }}
      >
        <Box className="suite-sidebar suite-sidebar-mobile">
          <SidebarContent
            usuario={session}
            onClose={onClose}
            collapsed={false}
            onToggleCollapse={onToggleCollapse}
            mobile={mobile}
          />
        </Box>
      </Drawer>
    )
  }

  return (
    <Box component="aside" className={`suite-sidebar${collapsed ? ' suite-sidebar-collapsed' : ''}`}>
      <SidebarContent
        usuario={session}
        onClose={onClose}
        collapsed={collapsed}
        onToggleCollapse={onToggleCollapse}
        mobile={mobile}
      />
    </Box>
  )
}
